import { graphql } from 'gql'

export const REBUILD_DOMAIN = graphql(`
  mutation rebuildDomain($input: RebuildDomainInput!) {
    rebuildDomain(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`)
